import React, { useState } from 'react';
import HeaderMain from "../components/header/HeaderMain";
import NavMain from "../components/nav/NavMain";
import AutosuggestComponent from "../document/AutosuggestComponent";
import DocumentRePastdueAccountFinalNoticeBeforeLegalAction from '../document/DocumentRePastdueAccountFinalNoticeBeforeLegalAction';


function RePastdueAccountFinalNoticeBeforeLegalAction() {
    const [applicantDetails, setApplicantDetails] = useState(null);
    const [loanProcessingDetails, setLoanProcessingDetails] = useState([]);

    return (
        <>
            <NavMain slug="re-pastdue-account-final-notice-before-legal-action" parent="6" />
            <HeaderMain slug="re-pastdue-account-final-notice-before-legal-action" />
            <div className="main-content documents">
                <AutosuggestComponent
                setApplicantDetails={setApplicantDetails}
                setLoanProcessingDetails={setLoanProcessingDetails}
                />
                <DocumentRePastdueAccountFinalNoticeBeforeLegalAction
                    applicantDetails={applicantDetails}
                    loanProcessingDetails={loanProcessingDetails}
                />
            </div>
        </>
    );
}

export default RePastdueAccountFinalNoticeBeforeLegalAction;